import { Sizes } from '@sede-x/shell-ds-react-base';

import Flexbox from '../../../Flexbox/Flexbox';
import Label from '../../../Text/components/Label/Label';
import Loading from '../../../Loading/Loading';
import { IModalLoadingProps } from './ModalLoading.types';

const ModalLoading = ({ loadingBody }: IModalLoadingProps) => (
  <Flexbox flexDirection="column" gap="12px" alignItems="center">
    <Loading size={Sizes.Large} />
    {typeof loadingBody === 'string' ? <Label size={Sizes.Large}>{loadingBody}</Label> : loadingBody}
  </Flexbox>
);

export default ModalLoading;
